import { useCCEntity } from "components/CC/context/CCEntityContext.tsx";
import { DrawerId, FormId } from "components/CC/types/models.ts";
import { BaseConnectionCreatorDrawer } from "components/CC/UI/BaseConnectionCreatorDrawer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

import { ModifyFieldForm } from "../Forms/ModifyFieldForm.tsx";

export const ModifyFieldDrawer = () => {
    const { formFields, customFields } = useCCEntity();
    const { t } = usePaldockTranslation("components.connection-creator");

    return (
        <BaseConnectionCreatorDrawer
            drawerId={DrawerId.ModifyField}
            title={t("nodes.modify.drawers.title")}
            width={1000}
        >
            <ModifyFieldForm formId={FormId.ModifyFieldForm} formFields={formFields} customFields={customFields} />
        </BaseConnectionCreatorDrawer>
    );
};
